import { useRecoilState } from 'recoil';
import { authAtom } from 'state/recoil-root';
import instance from 'helpers/instance';
import { totalRow } from 'state/roles-permissions';
import { listChannelGroupAtom } from 'state/show';

const useChannelGroupActions = () => {
  const [auth] = useRecoilState(authAtom);
  const [, setTotalRows] = useRecoilState(totalRow);
  const [, setChannelGroupList] = useRecoilState(listChannelGroupAtom);

  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  function getListChannelGroup(filter, page = 0, pageSize = 10) {
    let params = { ...filter };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = { offset, limit: pageSize, ...filter };
    }
    return instance({
      url: 'report-service/v1/channel-groups',
      method: 'GET',
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setChannelGroupList(res.data.data);
          setTotalRows((preState) => ({
            ...preState,
            channelGroups: res.data.meta.total,
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getChannelGroupDetail(id) {
    return instance({
      url: `report-service/v1/channel-groups/${id}`,
      method: 'GET',
      headers,
    });
  }

  function createChannelGroup(data) {
    return instance({
      url: 'report-service/v1/channel-groups',
      method: 'POST',
      headers,
      data,
    });
  }

  function updateChannelGroup(data, id) {
    return instance({
      url: `report-service/v1/channel-groups/${id}`,
      method: 'PUT',
      headers,
      data,
    });
  }

  function getChannelGroupsAll() {
    return instance({
      url: 'report-service/v1/channel-groups',
      method: 'GET',
      headers,
      params: { status: 1, offset: 0, limit: 1000 },
    });
  }

  function updateChannelGroupStatus(status, id) {
    return instance({
      url: `report-service/v1/channel-groups/${id}/status`,
      method: 'PATCH',
      headers,
      data: { status },
    });
  }

  return {
    getListChannelGroup,
    getChannelGroupsAll,
    getChannelGroupDetail,
    createChannelGroup,
    updateChannelGroup,
    updateChannelGroupStatus,
  };
};

export { useChannelGroupActions };
